import React, { useRef } from 'react';
import { Menu } from 'primereact/menu';
import { useNavigate } from 'react-router-dom';

const Navbar: React.FC = () => {
    const menu = useRef<Menu>(null);
    const navigate = useNavigate();

    // Función que se ejecuta al hacer clic en "Cerrar sesión"
    const handleLogout = () => {
        console.log("Redigiriendo...");

        // 🧹 Limpiar datos del localStorage
        localStorage.removeItem('authToken');
        localStorage.removeItem('idUsuario');
        localStorage.removeItem('nombreUsuario');

        // 🚪 Redirigir al login
        navigate('/login');
    };

    // Menú desplegable
    const items = [
        {
            label: 'Cuenta',
            icon: 'pi pi-user',
            items: [
                {
                    label: 'Iniciar sesión',
                    icon: 'pi pi-sign-out',
                    command: handleLogout,
                },
            ],
        },
    ];

    return (
        <nav className="main-header navbar navbar-expand navbar-white navbar-light">
            {/* Left navbar links */}
            <ul className="navbar-nav">
                <li className="nav-item">
                    <a className="nav-link" data-widget="pushmenu" href="#" role="button">
                        <i className="fas fa-bars" />
                    </a>
                </li>
                <li className="nav-item d-none d-sm-inline-block">
                    <a
                        href="#"
                        className="nav-link"
                        onClick={(e) => {
                            e.preventDefault();
                            navigate('/invinicio');
                        }}
                    >
                        Inicio
                    </a>
                </li>
                
            </ul>

            {/* Right navbar links */}
            <ul className="navbar-nav ml-auto">
                {/* Navbar Search */}
                <li className="nav-item">
                    <a className="nav-link" data-widget="navbar-search" href="#" role="button">
                        <i className="fas fa-search" />
                    </a>
                    <div className="navbar-search-block">
                        <form className="form-inline">
                            <div className="input-group input-group-sm">
                                <input
                                    className="form-control form-control-navbar"
                                    type="search"
                                    placeholder="Search"
                                    aria-label="Search"
                                />
                                <div className="input-group-append">
                                    <button className="btn btn-navbar" type="submit">
                                        <i className="fas fa-search" />
                                    </button>
                                    <button className="btn btn-navbar" type="button" data-widget="navbar-search">
                                        <i className="fas fa-times" />
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </li>

                <li className="nav-item">
                    <a className="nav-link" data-widget="fullscreen" href="#" role="button">
                        <i className="fas fa-expand-arrows-alt" />
                    </a>
                </li>

                {/* Botón de usuario y menú desplegable */}
                <li className="nav-item">
                    <Menu model={items} popup ref={menu} id="menu" />
                    <button
                        className="nav-link p-link"
                        onClick={(e) => menu.current?.toggle(e)}
                    >
                        <i className="pi pi-user" />
                    </button>
                </li>
            </ul>
        </nav>
    );
};

export default Navbar;